/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Eu_TextInputs */

const en_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data is processed in the EU. For current details on providers, regions, and data flows, see our Privacy Policy (/privacy). AI runs server-side — users never need to provide their own API keys.`)
};

const de_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten werden in der EU verarbeitet. Aktuelle Informationen zu Anbietern, Regionen und Datenfluessen findest du in unserer Datenschutzerklarung (/privacy). KI lauft serverseitig — Nutzer muessen keine eigenen API-Keys bereitstellen.`)
};

const fr_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les donnees sont traitees dans l'UE. Pour les informations actuelles sur les fournisseurs, regions et flux de donnees, consultez notre Politique de confidentialite (/privacy). L'IA fonctionne cote serveur — les utilisateurs n'ont jamais besoin de fournir leurs propres cles API.`)
};

const es_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los datos se procesan en la UE. Para obtener informacion actualizada sobre proveedores, regiones y flujos de datos, consulta nuestra Politica de privacidad (/privacy). La IA funciona en el servidor — los usuarios nunca necesitan proporcionar sus propias claves API.`)
};

const it_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dati vengono elaborati nell'UE. Per i dettagli aggiornati su fornitori, regioni e flussi di dati, consulta la nostra Informativa sulla privacy (/privacy). L'IA funziona lato server — gli utenti non devono mai fornire le proprie chiavi API.`)
};

const nl_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens worden verwerkt in de EU. Voor actuele informatie over aanbieders, regio's en gegevensstromen, raadpleeg ons Privacybeleid (/privacy). AI draait server-side — gebruikers hoeven nooit hun eigen API-sleutels te verstrekken.`)
};

const pl_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane sa przetwarzane w UE. Aktualne informacje o dostawcach, regionach i przeplywach danych znajdziesz w naszej Polityce prywatnosci (/privacy). AI dziala po stronie serwera — uzytkownicy nigdy nie musza podawac wlasnych kluczy API.`)
};

const fi_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoja kasitellaan EU:ssa. Ajantasaiset tiedot palveluntarjoajista, alueista ja tietovirroista loytyy tietosuojakaytannoistamme (/privacy). Tekoaly toimii palvelinpuolella — kayttajien ei koskaan tarvitse antaa omia API-avaimiaan.`)
};

const da_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data behandles i EU. For aktuelle oplysninger om udbydere, regioner og dataflows, se vores Privatlivspolitik (/privacy). AI korer serverside — brugere behover aldrig at angive deres egne API-nogler.`)
};

const sv_about_eu_text = /** @type {(inputs: About_Eu_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All data behandlas i EU. For aktuell information om leverantorer, regioner och datafloden, se var Integritetspolicy (/privacy). AI koer serverside — anvaendare behover aldrig tillhandahaalla egna API-nycklar.`)
};

/**
* | output |
* | --- |
* | "Data is processed in the EU. For current details on providers, regions, and data flows, see our Privacy Policy (/privacy). AI runs server-side — users never ..." |
*
* @param {About_Eu_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_eu_text = /** @type {((inputs?: About_Eu_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Eu_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_eu_text(inputs)
	if (locale === "fr") return fr_about_eu_text(inputs)
	if (locale === "es") return es_about_eu_text(inputs)
	if (locale === "it") return it_about_eu_text(inputs)
	if (locale === "nl") return nl_about_eu_text(inputs)
	if (locale === "pl") return pl_about_eu_text(inputs)
	if (locale === "fi") return fi_about_eu_text(inputs)
	if (locale === "da") return da_about_eu_text(inputs)
	if (locale === "sv") return sv_about_eu_text(inputs)
	return en_about_eu_text(inputs)
});